<div
  class="select"
  [class.active]="isComboOpen === true"
  (clickOutside)="closeWhenOutsideClick($event)"
  (attachOutsideOnClick)="(attachedClick)"
  tabindex="0"
>
  <div
    class="face-select"
    (click)="toggleCombo($event)"
    (keydown)="navDown($event)"
    tabindex="0"
  >
    <div *ngIf="isHTML" class="input__input html__container">
      <div
        class="html__value"
        [innerHTML]="selectedItem.name || placeholder"
      ></div>
    </div>
    <input
      *ngIf="!isHTML"
      value=""
      maxlength="250"
      [(ngModel)]="selectedItem.name || placeholder"
      [class.selected]="selected === true"
      type="text"
      disabled
      required
      (blur)="hideOrderList()"
      (click)="$event.target.select()"
      (keydown)="navDown($event)"
      class="input-search"
      tabindex="0"
    />
    <img
      class="combo-select__toggle-icon"
      src="images/icons/atm-arrow-icn-open.svg"
      [alt]="!isComboOpen ? 'Abrir' : 'Cerrar'"
    />
    <div class="error-message"></div>
  </div>

  <ng-template [ngIf]="isFunds">
    <ul class="result-list" id="combo-box-scroll">
      <li
        *ngFor="let orden of onlineList"
        (click)="setOrderType(orden)"
        data-type="{{ orden.id }}"
        class="option"
        tabindex="0"
        (keyup)="navDown($event, orden)"
      >
        {{ orden.name }}
      </li>

      <ng-template [ngIf]="hasOffline">
        <div class="offline-section">
          <li class="offline-text">FUERA DE HORARIO</li>
          <li
            *ngFor="let orden of offlineList"
            (click)="setOrderType(orden)"
            data-type="{{ orden.id }}"
            class="option"
            tabindex="0"
          >
            {{ orden.name }}
          </li>
        </div>
      </ng-template>
    </ul>
  </ng-template>

  <ng-template [ngIf]="!isFunds">
    <ul class="result-list" id="combo-box-scroll">
      <ng-template [ngIf]="isHTML">
        <ng-container *ngFor="let orden of resultsList">
          <li *ngIf="orden.isGroup" class="group">{{ orden.name }}</li>
          <li
            *ngIf="!orden.isGroup"
            (click)="setOrderType(orden)"
            data-type="{{ orden.id }}"
            [innerHTML]="orden.name"
            class="option"
            tabindex="0"
            (keyup)="navDown($event, orden)"
            data-recording-sensitive
          ></li>
        </ng-container>
      </ng-template>
      <ng-template [ngIf]="!isHTML">
        <ng-container *ngFor="let orden of resultsList">
          <li *ngIf="orden.isGroup" class="group">{{ orden.name }}</li>
          <li
            *ngIf="!orden.isGroup"
            (click)="setOrderType(orden)"
            data-type="{{ orden.id }}"
            class="option"
            [ngClass]="[
              !!orden?.data?.managementTypeTemplate ? 'option__strategy' : '',
              !!orden?.data?.managementTypeTemplate
                ? 'option__strategy--' + orden.data.managementTypeTemplate
                : ''
            ]"
            tabindex="0"
            (keyup)="navDown($event, orden)"
          >
            {{ orden.name }}
          </li>
        </ng-container>
      </ng-template>
    </ul>
  </ng-template>
</div>
